import {
  betslipToggle,
} from '@/betslip/betslip-store';
import {
  betslipToggleOptionsFromAccount,
  buildBetslipDraft,
} from '@/betslip/build-draft';
import { isSelectionInTicket, type BetslipTicket } from '@/domain/betslip';
import { getUserSettings, type Account } from '@/api/auth';
import type { EventOutcome } from '@/ui/sports/EventRow';

/** Mark outcomes selected when they exist on the current betslip. */
export function withBetslipSelectedState(
  ticket: BetslipTicket,
  eventId: string | number,
  outcomes: EventOutcome[],
): EventOutcome[] {
  return outcomes.map((outcome) => {
    if (outcome.state === 'locked' || outcome.state === 'suspended') return outcome;
    const marketId = outcome.marketId ?? outcome.id.split(':')[0];
    const outcomeCode = outcome.outcomeCode ?? outcome.outcome;
    const active = isSelectionInTicket(ticket, {
      eventId,
      marketId,
      specifier: outcome.specifier,
      outcome: outcomeCode,
    });
    return active ? { ...outcome, state: 'selected' as const } : outcome;
  });
}

export type BetslipEventSource = {
  EventId: number;
  Home?: string | null;
  Away?: string | null;
  HomeScore?: number | null;
  AwayScore?: number | null;
  Date?: string | null;
  Live?: boolean;
  Category?: string | null;
  Tournament?: string | null;
  TournamentId?: number | null;
  Sport?: string | null;
  SportId?: number;
};

/** Toggle a selection for an event/outcome pair (safe to call from map callbacks). */
export function selectOutcomeForEvent(
  event: BetslipEventSource,
  outcome: EventOutcome,
  account?: Account | null,
): void {
  const draft = buildBetslipDraft(event, outcome, {
    feedType: typeof account?.FeedType === 'number' ? account.FeedType : undefined,
  });
  if (!draft) return;
  betslipToggle(draft, betslipToggleOptionsFromAccount(account, getUserSettings()));
}
